// extracted by mini-css-extract-plugin
export default {"productImage":"A8MyOK","productBadge":"ZS7Zjy","badge":"i_sXQt","defaultImage":"C4eMHc"};